export default "{\n    \"connectToQuickBooks\": \"Connect to QuickBooks\",\n    \"connectedToQuickBooks\": \"Connected to Quickbooks\"\n}\n"